import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import MailCategorySelectorContainer from '../../../wizard/product-selector/containers/MailCategorySelectorContainer';
import MailCategories from '../../../wizard/product-selector/containers/MailCategories';
import {
  deSelectAllCategories,
  fetchMailClasses,
  selectAllCategories, showOnlySelectedMailClasses,
} from '../../../wizard/product-selector/redux/actions/ProductActions';
import {
  saveGlobalSelectionProductRequestActionCreator,
  setTabButtonStatus,
} from '../redux/actions/AdminDashboardActions';
import {
  getCheckedMailClasses,
  getIsShowOnlySelectedMailClasses,
} from '../../../wizard/product-selector/redux/selectors/MailClassesSelectors';
import AdminPresetProductHeaderBarContainer from './AdminPresetProductHeaderBarContainer';
import { createProductPresetSelectionsOnSave } from '../../../react-table/helpers/utils';

export class GlobalPresetsDespatchTypeContainer extends Component {
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
  }

  componentDidMount() {
    this.props.fetchMailClasses(this.props.checkedMailClasses);
  }

  componentDidUpdate(prevProps) {
    if (this.props.checkedMailClasses.length !== prevProps.checkedMailClasses.length && this.props.checkedMailClasses.length !== 0) {
      this.props.setTabButtonStatus(true);
    }
  }

  selectAll = () => {
    this.props.selectAllCategories();
  };

  deSelectAll = () => {
    this.props.deSelectAllCategories();
  };

  saveSelection = (values) => {
    const selections = createProductPresetSelectionsOnSave(this.props.productSelector.categories, this.props.productSelector.mailClassNodes);
    this.props.saveGlobalSelectionProductRequestActionCreator(
      values.name,
      selections,
    );

    this.toggleModal();
  };

  toggleModal = () => {
    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate
      showModal: !this.state.showModal,
    });
  };

  render() {
    return (
      <div className="product-selection-wrapper">
        <div className="product-selection">
          <div className="product-selection-header">
            <AdminPresetProductHeaderBarContainer
              categoryOnlySelection={false}
              selections={this.props.productSelector.selections}
              categories={this.props.productSelector.categories}
            />
          </div>
          <div className="product-selection-content">
            <div className="product-tree">
              <MailCategorySelectorContainer
                mailCategory={MailCategories.a.code}
                description={MailCategories.a.description}
                expandDisabled={false}
              />
            </div>

            <div className="product-tree">
              <MailCategorySelectorContainer
                mailCategory={MailCategories.b.code}
                description={MailCategories.b.description}
                expandDisabled={false}
              />
            </div>

            <div className="product-tree">
              <MailCategorySelectorContainer
                mailCategory={MailCategories.c.code}
                description={MailCategories.c.description}
                expandDisabled={false}
              />
            </div>

            <div className="product-tree">
              <MailCategorySelectorContainer
                mailCategory={MailCategories.d.code}
                description={MailCategories.d.description}
                expandDisabled={false}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

GlobalPresetsDespatchTypeContainer.propTypes = {
  fetchMailClasses: PropTypes.func,
  selectAllCategories: PropTypes.func,
  deSelectAllCategories: PropTypes.func,
  // eslint-disable-next-line react/no-unused-prop-types
  isShowOnlySelected: PropTypes.bool,
  // eslint-disable-next-line react/no-unused-prop-types
  onShowOnlySelected: PropTypes.func,
  saveGlobalSelectionProductRequestActionCreator: PropTypes.func,
  productSelector: PropTypes.objectOf(PropTypes.shape),
  checkedMailClasses: PropTypes.arrayOf(PropTypes.string),
  setTabButtonStatus: PropTypes.func,
};

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchMailClasses,
  selectAllCategories,
  deSelectAllCategories,
  onShowOnlySelected: showOnlySelectedMailClasses,
  saveGlobalSelectionProductRequestActionCreator,
  setTabButtonStatus,
}, dispatch);

const mapStateToProps = state => ({
  checkedMailClasses: getCheckedMailClasses(state),
  isShowOnlySelected: getIsShowOnlySelectedMailClasses(state),
  productSelector: state.productSelector,
});

/* Needed for prop-types with cloneElement */
export const ConnectedGlobalPresetsDespatchTypeContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(GlobalPresetsDespatchTypeContainer);

export default (ConnectedGlobalPresetsDespatchTypeContainer);
